webpackJsonp([107],{

/***/ 2342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpCognito_vue__ = __webpack_require__(3154);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d1bd01_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpCognito_vue__ = __webpack_require__(3631);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3629)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpCognito_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d1bd01_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpCognito_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/public/account/SignUpCognito.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-66d1bd01", Component.options)
  } else {
    hotAPI.reload("data-v-66d1bd01", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["m" /* BForm */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */],
    BFormRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["w" /* BFormRow */],
    BCol: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["i" /* BCol */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */]
  },
  data: function data() {
    return {
      success: null,
      form: {
        email: null,
        password: null,
        name: null,
        surname: null,
        dni: null,
        phone: null,
        rol: null
      },
      availableRoles: [{ value: null, text: this.$t('select-an-option'), disabled: true }, { value: 'Professional', text: this.$t('professional') }, { value: 'Patient', text: this.$t('patient') }, { value: 'Patient', text: this.$t('center') }]
    };
  },

  methods: {
    signUp: function signUp() {
      var _this = this;

      this.$userApi.post('Cognito/SignUp', {
        email: this.form.email,
        password: this.form.password,
        given_name: this.form.name,
        family_name: this.form.surname,
        national_identity: this.form.dni,
        phone_number: this.form.phone,
        rol: this.form.rol
      }).then(function (response) {
        if (response.data.data) {
          _this.success = true;
        }
      }).catch(function (error) {
        if (error) {
          _this.success = false;
        }
      });
    }
  }
});

/***/ }),

/***/ 3629:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3630);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3a9f358f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-66d1bd01\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SignUpCognito.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-66d1bd01\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SignUpCognito.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3630:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 3631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.success
      ? _c("div", [
          _vm._v("\n    " + _vm._s(_vm.$t("signup-success")) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.success === false
      ? _c("div", [
          _vm._v("\n    " + _vm._s(_vm.$t("signup-unsuccessful")) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.success
      ? _c(
          "div",
          [
            _c(
              "b-form",
              {
                on: {
                  submit: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.signUp.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "b-form-group",
                  [
                    _c("b-form-input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("login.email")
                      },
                      model: {
                        value: _vm.form.email,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "mt-4",
                      attrs: {
                        type: "password",
                        placeholder: _vm.$t("login.password")
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "mt-4",
                      attrs: { type: "text", placeholder: _vm.$t("name") },
                      model: {
                        value: _vm.form.name,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "mt-4",
                      attrs: { type: "text", placeholder: _vm.$t("surname") },
                      model: {
                        value: _vm.form.surname,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "surname", $$v)
                        },
                        expression: "form.surname"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-select", {
                      staticClass: "mt-4",
                      attrs: { options: _vm.availableRoles },
                      model: {
                        value: _vm.form.rol,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rol", $$v)
                        },
                        expression: "form.rol"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-form-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "b-col",
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t(
                                  "national-identity-document"
                                )
                              },
                              model: {
                                value: _vm.form.dni,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "dni", $$v)
                                },
                                expression: "form.dni"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("phone")
                              },
                              model: {
                                value: _vm.form.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "phone", $$v)
                                },
                                expression: "form.phone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "w-100 mt-4",
                        attrs: { variant: "primary", type: "submit" }
                      },
                      [_vm._v(_vm._s(_vm.$t("sign-up")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66d1bd01", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/107.8018c98db468fa76962f.js